<template>
  <div class="sobre">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="vs-eyebrow mb-2">INSTITUTO MÉDICO</div>
          <h1 class="display-2 font-weight-bold" style="font-family: 'Roboto Condensed', sans-serif; color: #030a1a;">Veri Salvatori</h1>
          <p class="subheading mt-4" style="text-align: justify; color: #505d74; font-family: 'Inter', sans-serif; line-height: 1.6;">
            Informamos que o módulo de flashcards já está disponível como parte da nova atualização da plataforma Veri Salvatori, trazendo também uma interface renovada para tornar a navegação ainda mais intuitiva. O módulo de flashcards está em constante desenvolvimento, e melhorias serão implementadas continuamente para aprimorar sua experiência.</p>
        </v-col>
      </v-row>
      <!-- Adicione o v-stepper aqui -->
      <v-stepper :items="['1° Passo', '2° Passo', '3° Passo']" class="mt-5" prev-text="Anterior" next-text="Próximo">
        <template v-slot:item.1>
          <v-card title="1° Passo" flat>1. Na aba Decks, navegue entre os Decks disponíveis. 
            <br>2. Clique no botão <v-icon>mdi-play</v-icon>para iniciar os estudos.</v-card> 
        </template>

        <template v-slot:item.2>
          <v-card title="2° Passo" flat>1. O primeiro Card é sempre uma pergunta ou informação. 
            <br>2. Clique em resposta para mostrar o outro lado que contém a resposta ou conceito correspondente.
            <br>3. Ao final, selecione o nível de dificuldade para esse card.  
          </v-card>
        </template>

        <template v-slot:item.3>
          <v-card title="3° Passo" flat>Revise os Cards constantemente, nosso algoritmo de repetição está em desenvolvimento e irá sempre mostrar o conteúdo mais relevante baseado no seu progresso.
            <br>
            Você também podem acompanhar seu progresso pela aba Métricas.

          </v-card>
        </template>
      </v-stepper>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Sobre',
};
</script>

<style scoped>
.sobre {
  background-color: #ffffff;
  padding: 32px 28px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 30px -5px rgba(3, 10, 26, 0.05);
  text-align: center;
}

.sobre h1 {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.sobre p {
  font-size: 1.2rem;
  color: #333;
}

/* Responsividade para dispositivos móveis */
@media screen and (max-width: 600px) {
  .sobre h1 {
    font-size: 2rem;
  }
  .sobre p {
    font-size: 1rem;
  }
}
</style>
